import { Controller } from "stimulus"

/**
 * 年月日SelectBoxの日付制御コントローラ
 */
export default class extends Controller {
  static targets = ["year", "month", "day"]

  connect() {    
    this.initDefault()
    this.updateDaysFromTargets()
    this.birthYearToAgeVerificationDefault()
  }

  /**
   * 年の変更イベントを監視
   */
  yearChanged() {
    this.updateDaysFromTargets()
  }

  /**
   * 月の変更イベントを監視
   */
  monthChanged() {
    this.updateDaysFromTargets()
  }

  /**
   * 日の変更イベントを監視
   */
  dateChanged(event) {
    // 全てのselectを取得
    const $selectElement = $(event.target)
    
    // 関連するフィールドの特定
    const nameBase = $selectElement.attr('name').split('(')[0].replace(/\[\d+\]$/, '')
    
    // このフィールドに関連する年月日のセレクトボックスを特定
    const $selects = $(this.element).find('select')
    const yearSelect = $selects.filter(function() {
      return $(this).attr('name') && $(this).attr('name').startsWith(nameBase) && $(this).attr('name').includes('1i')
    })[0]

    const monthSelect = $selects.filter(function() {
      return $(this).attr('name') && $(this).attr('name').startsWith(nameBase) && $(this).attr('name').includes('2i')
    })[0]

    const daySelect = $selects.filter(function() {
      return $(this).attr('name') && $(this).attr('name').startsWith(nameBase) && $(this).attr('name').includes('3i')
    })[0]

    if (yearSelect && monthSelect && daySelect) {
      this.updateDays(yearSelect, monthSelect, daySelect)
    }
  }
  
  /**
   * ターゲット要素から日付を更新
   */
  updateDaysFromTargets() {
    if (this.hasYearTarget && this.hasMonthTarget && this.hasDayTarget) {
      this.updateDays(this.yearTarget, this.monthTarget, this.dayTarget)
    }
  }

  /**
   * デフォルト値初期化
   */
  initDefault() {
    const detectedGroups = []
    
    const $selects = $(this.element).find('select')
    const fieldGroups = new Map()
    
    $selects.each(function() {
      const select = this
      const name = $(select).attr('name')

      if (!name) return

      const match = name.match(/\[([^\]]+)\]/)
      if (!match) return

      const fieldName = match[1]

      if (!fieldGroups.has(fieldName)) {
        fieldGroups.set(fieldName, { year: null, month: null, day: null })
      }

      const group = fieldGroups.get(fieldName)

      if (name.includes('1i')) {
        group.year = select
      } else if (name.includes('2i')) {
        group.month = select
      } else if (name.includes('3i')) {
        group.day = select
      }
    })

    // 各グループに対して初期化を実行
    for (const [, group] of fieldGroups.entries()) {
      if (group.year && group.month && group.day) {
        detectedGroups.push(group)
      }
    }
    
    if (detectedGroups.length === 0) {
      // セレクタパターンでの要素検索
      const yearSelect = $selects.filter(function() {
        const name = $(this).attr('name')
        return name && (
          name.includes('1i') ||
          name.match(/year|年/) ||
          name.match(/\[\d*\]\[1i\]$/) ||
          name.match(/_year_/)
        )
      })[0]
      
      const monthSelect = $selects.filter(function() {
        const name = $(this).attr('name')
        return name && (
          name.includes('2i') ||
          name.match(/month|月/) ||
          name.match(/\[\d*\]\[2i\]$/) ||
          name.match(/_month_/)
        )
      })[0]
      
      const daySelect = $selects.filter(function() {
        const name = $(this).attr('name')
        return name && (
          name.includes('3i') ||
          name.match(/day|日/) ||
          name.match(/\[\d*\]\[3i\]$/) ||
          name.match(/_day_/)
        )
      })[0]
      
      if (yearSelect && monthSelect && daySelect) {
        detectedGroups.push({ year: yearSelect, month: monthSelect, day: daySelect })
      }
    }
    
    // 検出したグループに対してイベントリスナーと初期更新を設定
    if (detectedGroups.length > 0) {
      detectedGroups.forEach(group => {
        this.setupDateFields(group.year, group.month, group.day)
      })
    }
  }
  
  /**
   * 日付フィールドの設定
   */
  setupDateFields(yearElem, monthElem, dayElem) {
    // イベントリスナーを一度削除してから再設定（重複防止）
    $(yearElem).off('change.dateSelector')
               .on('change.dateSelector', () => this.updateDays(yearElem, monthElem, dayElem))

    $(monthElem).off('change.dateSelector')
                .on('change.dateSelector', () => this.updateDays(yearElem, monthElem, dayElem))

    // 初期状態の更新
    this.updateDays(yearElem, monthElem, dayElem)
  }

  /**
   * 年月に応じて日の選択肢を更新
   */
  updateDays(yearElem, monthElem, dayElem) {
    // 月の値を取得
    const month = parseInt($(monthElem).val(), 10)
    
    // 年が未選択の場合でも、月に応じた日数制限を行う
    if (isNaN(month)) {
      return
    }
    
    // 年の値を取得
    const year = parseInt($(yearElem).val(), 10) || new Date().getFullYear()
        
    // 現在選択されている日
    const currentDay = parseInt($(dayElem).val(), 10) || 1
    
    // 月の日数を計算
    const daysInMonth = new Date(year, month, 0).getDate()
    
    // 既存のoptions要素を取得
    const $dayElem = $(dayElem)
    const hasEmptyOption = $dayElem.find('option[value=""]').length > 0
    const emptyOptionText = hasEmptyOption ? $dayElem.find('option[value=""]').text() : ''
    
    // 日のオプションを構築
    $dayElem.empty()
    
    // 空のオプションを保持
    if (hasEmptyOption) {
      $dayElem.append($('<option>', {
        value: '',
        text: emptyOptionText
      }))
    }
    
    // 日の選択肢を追加
    for (let i = 1; i <= daysInMonth; i++) {
      $dayElem.append($('<option>', {
        value: i,
        text: i
      }))
    }
    
    // 前回選択していた日が有効範囲なら維持、そうでなければ末日に設定
    $dayElem.val(currentDay <= daysInMonth ? currentDay : daysInMonth)
  }

  // 年齢確認用の生年月日セレクトボックス
  birthYearToAgeVerificationDefault() {
    // 年のセレクトボックスを取得
    const yearSelect = this.element.querySelector('select[name$="[birth_date(1i)]"]');
    if (!yearSelect) return;

    yearSelect.addEventListener('focus', () => {
      // すでに選択状態である場合は、初期値設定は行わない
      if (yearSelect.value) return;

      // 現在の年の30年前を計算
      const targetYear = new Date().getFullYear() - 30
      for (let i = 0; i < yearSelect.options.length; i++) {
        if (parseInt(yearSelect.options[i].value, 10) === targetYear) {
          // 該当年にスクロール
          yearSelect.selectedIndex = i
          yearSelect.options[i].scrollIntoView({ block: "nearest" })
          break
        }
      }
    })
  }
}